import { API } from './instances'

export const getNotification = async data => {
    const url = '/Notificaciones/Get'
    return await API.get(url, { params: data })
}